import React, {PropTypes} from 'react';
import cookies from '../util/cookie';
import {connect} from 'react-redux';
import {Link, browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import CONSTANTS from '../common_constants';
import shipmentActions from './shipment_actions.jsx';
import authActions from '../auth/auth_actions';
import LoggedinFooter from '../footer/loggedin_footer';
import PackageInfo from './package_info';
import './offers.less';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import MessageThread from '../messages/message_thread_component';
import ShowError from '../components/error/show_error';

class ShipmentOffers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  getShipmentInfo(shipment){
    return({
      shipmentId: shipment.shipmentId || '',
      imageUrl: shipment.thumbnailImage || "",
      title: shipment.title || "",
      recipient: (shipment.deliverTo || "") + " | " + (shipment.deliveryLandmark || "") + (shipment.deliveryLocation || ""),
      packageSize: CONSTANTS.packageSize[shipment.itemSize],
      shipmentCost: "$" + shipment.shipmentCost
    });
  }

  getShipmentOffers = (shipmentId) => {
    const self = this;
    const {shipmentActions} = this.props;
    self.setState({isLoading: true});

    shipmentActions.getShipmentOffers(shipmentId).then((data) => {
      self.setState({
        shipment: data,
        shipmentId: shipmentId,
        isLoading: false,
        error: ''
      });
    }, (errorRes) => {
      if(errorRes.error === CONSTANTS.sessionInvalid){
        self.setState({
          isLoading: false,
        });
        props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
      self.setState({
        isLoading: false,
        error: errorRes.error
      })
    });
  }
  componentDidMount(){
    const {props} = this;
    const shipmentId = props.params.shipmentId;
    this.getShipmentOffers(shipmentId);
  }

  formatOfferInfo = (offer,shipmentId,shipmentTitle) => {
    return({
        profileImgUrl: offer.carrierImgUrl||"../../public/images/user_placeholder.svg",
        name: offer.carrierName,
        message: offer.message,
        created:  offer.created,
        title: shipmentTitle,
        shipmentId: shipmentId,
        carrierId: offer.carrierId,
        isVerified: offer.isVerified
    })
  }

  render() {
    const {state, props} = this;
    const {userData} = props.authState;

    let sessionValid = true ;
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid

    let user = { name: '', imageUrl: '', isVerified: ''};

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return (
      <div className = "shipment-offers-page">
        <DashBoardHeader user={user} logout={this.logout} />
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        <div className = "d-header-wrap">
          <div className = "wrapper">
            {state.shipment && <PackageInfo
              shipmentInfo = {this.getShipmentInfo(state.shipment)}
              shipmentId={state.shipmentId}
              showCancelShipment = {false}
              authState = {this.props.authState}
            />}
          </div>
        </div>
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {state.error && <ShowError errorMessage={state.error}/>}
        <div className = "shipment-offered-list-wrap">
          <div className = "wrapper header-wrapper">
            {state.shipment && <h2 className = "offers-header">Offers Received ({state.shipment.noOfOffers})</h2>}
          </div>
          <div className = "shipment-offered-list">
            {
              state.shipment && state.shipment.offers && state.shipment.offers.length>0 && state.shipment.offers.map( (offer, key) => {
                return(
                  <MessageThread
                    key={key}
                    message={this.formatOfferInfo(offer,state.shipmentId,state.shipment.title)}
                    shipmentId={state.shipmentId}
                    agentType = "shipper"
                  />
                )
              })
            }
          </div>
        </div>
        <LoggedinFooter />
      </div>
    );
  }
}
ShipmentOffers = connect((state) => {
  return {
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(ShipmentOffers);

module.exports = ShipmentOffers;



// WEBPACK FOOTER //
// app/shipment/offers.jsx